var _rect, _path, _path2, _rect2, _rect3, _path3, _line, _path4, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorFoodCourt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.577,
    y: 9.074,
    width: 24.845,
    height: 3.799,
    rx: 1.9,
    ry: 1.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.108,32.926h-2.56c-.414,0-.713-.397-.598-.795l5.244-16.125h3.855l-5.344,16.471c-.077.266-.321.449-.598.449Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.726,32.926h2.56c.414,0,.713-.397.598-.795l-5.244-16.125h-3.855s5.344,16.471,5.344,16.471c.077.266.321.449.598.449Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77,
    y: 17.983,
    width: 7.949,
    height: 2.378,
    rx: 0.622,
    ry: 0.622
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.281,
    y: 17.983,
    width: 7.949,
    height: 2.378,
    rx: 0.622,
    ry: 0.622
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.72,26.688H3.393c-.344,0-.622-.279-.622-.622v-1.911c0-.344.279-.622.622-.622h9.353"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.25,
    y1: 26.688,
    x2: 15.583,
    y2: 26.688
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29.087,23.533h9.52c.344,0,.622.279.622.622v1.911c0,.344-.279.622-.622.622h-8.494"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.607,
    y1: 23.533,
    x2: 25.226,
    y2: 23.533
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorFoodCourt);
export default __webpack_public_path__ + "static/media/indoor-food_court.732c8ee90d8250dade5a7611e83a31b5.svg";
export { ForwardRef as ReactComponent };